import { render } from "./CartSummary.vue?vue&type=template&id=12bff796&scoped=true"
import script from "./CartSummary.vue?vue&type=script&lang=js"
export * from "./CartSummary.vue?vue&type=script&lang=js"

import "./CartSummary.vue?vue&type=style&index=0&id=12bff796&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bff796"]])

export default __exports__